<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 22 22"
  >
    <g
      transform="translate(-1 -1)"
      fill="none"
    >
      <circle
        fill="#FFB400"
        cx="12"
        cy="12"
        r="11"
      />
      <path
        d="m11.54 16.25-2.45 1.28a1 1 0 0 1-1.45-1.06l.47-2.71a1 1 0 0 0-.3-.9l-1.97-1.92a1 1 0 0 1 .56-1.7l2.73-.4a1 1 0 0 0 .75-.55l1.22-2.47a1 1 0 0 1 1.8 0l1.22 2.47a1 1 0 0 0 .75.55l2.73.4a1 1 0 0 1 .56 1.7l-1.98 1.93a1 1 0 0 0-.29.89l.47 2.72a1 1 0 0 1-1.45 1.05l-2.45-1.28a1 1 0 0 0-.93 0z"
        fill="#fff"
      />
    </g>
  </svg>
</template>
